export const numberTitle = "Mobile Number";
export const numberSubtitle = "Enter Mobile Number";
export const telcoTitle = "Select Telco";
export const telcoSubtitle = "Choose your Telco";
export const productTitle = "Available Products";
export const productSubtitle = "Choose Available Products";
export const loadSubtitle = "Select Product SKU";
